import script from "./notification.vue?vue&type=script&setup=true&lang=js"
export * from "./notification.vue?vue&type=script&setup=true&lang=js"

import "./notification.vue?vue&type=style&index=0&id=46b9eb58&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b9eb58"]])

export default __exports__